import AutoCompleteActionTypes from './types';

export const searchStart = (payload: any) => ({
  type: AutoCompleteActionTypes.SEARCH_START,
  payload,
});

export const searchSuccess = (payload: any) => ({
  type: AutoCompleteActionTypes.SEARCH_SUCCESS,
  payload,
});

export const searchFailure = () => ({
  type: AutoCompleteActionTypes.SEARCH_FAILURE,
});

export const resetList = () => ({
  type: AutoCompleteActionTypes.RESET_LIST,
});

export const saveSelectedPlace = (payload: any) => ({
  type: AutoCompleteActionTypes.SAVE_SELECTED_PLACE,
  payload,
});

export const unLoadingSearchResultsStart = (payload: any) => ({
  type: AutoCompleteActionTypes.UNLOADING_SEARCH_RESULTS_START,
  payload: payload,
});
export const unLoadingSearchResultsSuccess = (payload: any) => ({
  type: AutoCompleteActionTypes.UNLOADING_SEARCH_RESULTS_SUCCESS,
  payload: payload,
});
export const unLoadingSearchResultsFailure = (payload: any) => ({
  type: AutoCompleteActionTypes.UNLOADING_SEARCH_RESULTS_FAILURE,
  payload: payload,
});
